import { STORAGE_BUCKET_PREFIX } from './config';

export const beesprintId = 'beesprint-12vc7';

export const getTenantLogoUrl = (tenantId: string) => {
  return `https://storage.googleapis.com/${STORAGE_BUCKET_PREFIX}_tenants-logos/${tenantId}.jpg`;
};

